import 'moment/locale/zh-cn';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import { useOrderContext } from '../../../../../providers/OrderProvider';
import formatCurrency from '../../../../../utils/formatCurrency';

const PaymentDetail = () => {
	const { order } = useOrderContext();
	const totalPrice = order?.totalPrice;
	return (
		<>
			<Row>
				<Col>{totalPrice && <EventModalMediaContent icon='dollar-sign' heading='总价' content={formatCurrency(totalPrice)} />}</Col>
			</Row>
		</>
	);
};

export default PaymentDetail;
